import React, { FC, HTMLAttributes } from 'react';
import { cn } from '../../utility/cn';

// --- Types ---

type AlertVariant = 'primary' | 'success' | 'danger' | 'warning' | 'info';

interface AlertProps extends HTMLAttributes<HTMLDivElement> {
    variant?: AlertVariant;
    className?: string;
    children: React.ReactNode;
}

interface AlertContentProps extends HTMLAttributes<HTMLHeadingElement | HTMLDivElement> {
    className?: string;
    children: React.ReactNode;
}


/**
 * Main container for the Alert
 */
export const Alert: FC<AlertProps> = ({
    variant = 'primary',
    className,
    children,
    ...props
}) => {
    return (
        <div
            role="alert"
            className={cn("alert", `alert-${variant}`, "d-flex flex-column", className)}
            {...props}
        >
            <div className="d-flex flex-column">
                {children}
            </div>
        </div>
    );
};


export const AlertTitle: FC<AlertContentProps> = ({ className, children, ...props }) => {
    return (
        <h5 className={cn("alert-heading fw-bolder mb-1", className)} {...props}>
            {children}
        </h5>
    );
};

/**
 * The body text of the alert
 */
export const AlertDescription: FC<AlertContentProps> = ({ className, children, ...props }) => {
    return (
        <div className={cn("fs-6", className)} {...props}>
            {children}
        </div>
    );
};


// how to use
// return (
//         <Alert variant="info">
//             <AlertDescription>No credit transactions found.</AlertDescription>
//         </Alert>
//     );